import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Plus, Trash2, Star, Save } from "lucide-react";

const empty = { name: "", role: "", rating: 5, text: "", order: 0 };

export default function ReviewsAdmin() {
  const [reviews, setReviews] = useState([]);
  const [form, setForm] = useState(empty);
  const [editingId, setEditingId] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = () => api.get("/reviews").then((r) => setReviews(r.data)).finally(() => setLoading(false));
  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));
  const reset = () => { setForm(empty); setEditingId(null); };

  const save = async () => {
    if (!form.name.trim() || !form.text.trim()) { alert("Name and review text are required"); return; }
    if (editingId) await api.put(`/admin/reviews/${editingId}`, form);
    else await api.post("/admin/reviews", form);
    reset();
    load();
  };
  const edit = (r) => { setForm(r); setEditingId(r.id); window.scrollTo({ top: 0, behavior: "smooth" }); };
  const remove = async (id) => {
    if (!window.confirm("Delete this review?")) return;
    await api.delete(`/admin/reviews/${id}`);
    load();
  };

  const inputCls = "w-full px-4 py-3 rounded-lg bg-[#0b0e13] border border-white/10 text-white focus:border-[#2f9fe6] outline-none transition-colors";

  return (
    <div className="max-w-4xl">
      <h1 className="text-white font-display text-4xl font-bold mb-1">Reviews</h1>
      <p className="text-[#6b7683] mb-8">Client testimonials shown on your website.</p>

      <div className="bg-[#141a22] rounded-xl p-6 border border-white/5 mb-10">
        <h2 className="text-white font-semibold mb-4">{editingId ? "Edit review" : "Add a review"}</h2>
        <div className="grid sm:grid-cols-2 gap-4 mb-4">
          <input className={inputCls} value={form.name} onChange={(e) => set("name", e.target.value)} placeholder="Client name" />
          <input className={inputCls} value={form.role} onChange={(e) => set("role", e.target.value)} placeholder="Project type (e.g. Kitchen Remodel)" />
        </div>
        <div className="flex items-center gap-2 mb-4">
          <span className="text-sm text-[#9aa4af] mr-2">Rating</span>
          {[1, 2, 3, 4, 5].map((n) => (
            <button key={n} type="button" onClick={() => set("rating", n)}>
              <Star className={`w-6 h-6 ${n <= form.rating ? "fill-[#2f9fe6] text-[#2f9fe6]" : "text-[#3a434e]"}`} />
            </button>
          ))}
        </div>
        <textarea rows={3} className={`${inputCls} mb-4`} value={form.text} onChange={(e) => set("text", e.target.value)} placeholder="Review text..." />
        <div className="flex items-center gap-3">
          <button onClick={save} className="flex items-center gap-2 px-6 py-2.5 rounded-lg bg-[#2f9fe6] text-white font-semibold hover:bg-[#1f82c7]"><Save className="w-4 h-4" /> {editingId ? "Update" : "Add"}</button>
          {editingId && <button onClick={reset} className="px-4 py-2.5 text-[#9aa4af] hover:text-white">Cancel</button>}
        </div>
      </div>

      {loading ? <div className="text-[#6b7683]">Loading...</div> : (
        <div className="space-y-4">
          {reviews.map((r) => (
            <div key={r.id} className="bg-[#141a22] rounded-xl p-6 border border-white/5 flex items-start gap-4">
              <div className="flex-1">
                <div className="flex mb-2">{[...Array(r.rating || 5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-[#2f9fe6] text-[#2f9fe6]" />)}</div>
                <p className="text-[#c7ced5] text-sm mb-2">“{r.text}”</p>
                <div className="text-white font-semibold text-sm">{r.name}</div>
                <div className="text-[#6b7683] text-xs">{r.role}</div>
              </div>
              <div className="flex gap-2">
                <button onClick={() => edit(r)} className="px-3 py-2 rounded-lg bg-white/5 text-white text-sm hover:bg-white/10">Edit</button>
                <button onClick={() => remove(r.id)} className="px-3 py-2 rounded-lg bg-white/5 text-[#9aa4af] hover:text-red-400 hover:bg-red-500/10"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
